// (function () {
//   function cleanup() {
//     // 1) Remove the DS helper text line
//     document.querySelectorAll("p, small, span, div").forEach((el) => {
//       const t = (el.textContent || "").trim().toLowerCase();
//       if (t === "add a gift note (optional)" || t === "add a gift message (optional)" || t === "add a gift note(optional)") {
//         el.remove();
//       }
//     });

//     // 2) Remove DS textarea message box (keep your GiftMessage/order note)
//     document.querySelectorAll("textarea").forEach((ta) => {
//       if (ta.id === "GiftMessage" || ta.name === "note") return;
//       // DS textarea is typically empty placeholder; remove it
//       // (We only run on cart pages below)
//       ta.remove();
//     });

//     // 3) Replace heading text if DS uses Gift wording
//     document.querySelectorAll("h1,h2,h3,h4,div,p,span,strong").forEach((el) => {
//       const t = (el.textContent || "").trim();
//     if (t === "Gift & Delivery Options" || t === "Gift and Delivery Options") {
//   el.textContent = "Delivery Date";

//       }
//     });
//   }

//   function shouldRun() {
//     // Runs on cart page + cart drawer contexts
//     return (
//       document.documentElement.classList.contains("template-cart") ||
//       window.location.pathname === "/cart" ||
//       document.querySelector("cart-drawer") ||
//       document.querySelector(".cart-drawer")
//     );
//   }

//   if (!shouldRun()) return;

//   cleanup();
//   new MutationObserver(cleanup).observe(document.documentElement, { childList: true, subtree: true });
//   setTimeout(cleanup, 300);
//   setTimeout(cleanup, 1200);
// })();


document.addEventListener("DOMContentLoaded", function () {
  const checkbox = document.getElementById("shipping-policy-checkbox");
  const checkoutBtn = document.querySelector(
    'button.cart__checkout-button[name="checkout"]'
  );

  if (!checkbox || !checkoutBtn) return;

  function updateState() {
    const enabled = checkbox.checked;
    checkoutBtn.disabled = !enabled;
    checkoutBtn.style.opacity = enabled ? "1" : "0.5";
    checkoutBtn.style.pointerEvents = enabled ? "auto" : "none";
  }

  updateState();
  checkbox.addEventListener("change", updateState);
});
document.addEventListener('DOMContentLoaded', () => {
  const checkbox = document.getElementById('shipping-agreement-checkbox');
  const checkoutBtn = document.getElementById('checkout');

  if (!checkbox || !checkoutBtn) return;

  // Disable checkout by default
  checkoutBtn.disabled = true;
  checkoutBtn.classList.add('disabled');

  checkbox.addEventListener('change', () => {
    checkoutBtn.disabled = !checkbox.checked;
    checkoutBtn.classList.toggle('disabled', !checkbox.checked);
  });
});
document.addEventListener("DOMContentLoaded", () => {
  // 1) Find the policy checkbox (your checkbox lives inside this wrapper)
  const checkbox =
    document.querySelector(".cart-policy-confirmation input[type='checkbox']") ||
    document.querySelector(".cart-policy-label input[type='checkbox']");

  // 2) Find the REAL checkout button (you had duplicates earlier, so grab the last one)
  const checkoutButtons = Array.from(document.querySelectorAll("button#checkout"));
  const checkoutBtn = checkoutButtons.length ? checkoutButtons[checkoutButtons.length - 1] : null;

  if (!checkbox || !checkoutBtn) return;

  // Helper to toggle button state
  const setCheckoutState = () => {
    const allowed = checkbox.checked;

    checkoutBtn.disabled = !allowed;
    checkoutBtn.classList.toggle("disabled", !allowed);

    // Extra safety: prevent clicking when disabled (some themes still allow interaction)
    checkoutBtn.style.pointerEvents = allowed ? "" : "none";
    checkoutBtn.style.opacity = allowed ? "" : "0.5";
  };

  // Run once on load + whenever checkbox changes
  setCheckoutState();
  checkbox.addEventListener("change", setCheckoutState);
});
